import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DepartmentHero,
  DepartmentAbout,
  DepartmentCTA,
  DepartmentServices,
} from '../components/departments';
import Counter from '../components/Counter';
import Testimonials from '../components/Testimonials';

// Icônes
import {
  faChartBar,
  faMobileAlt,
  faPaintBrush,
  faNewspaper,
  faChartLine,
  faGlobe,
  faUsers,
  faFileAlt,
  faFolder,
  faAward,
} from '@fortawesome/free-solid-svg-icons';

// Images (à adapter selon vos noms réels)
import chefImage from '../images/DMC_450x500.webp';
import logoMarketing from '../images/logo_ATC_com&marke.webp';
import strategieImg from '../images/strategie_conseil.webp';
import digitalImg from '../images/marketing_digital.webp';
import creationImg from '../images/creation_contenu.webp';
import presseImg from '../images/relationPresse_media.webp';
import analyseImg from '../images/analyse_performance.webp';
import internationalImg from '../images/communication_internationnale.webp';
import temoin1 from '../images/temoin_marketing1.webp';
import temoin2 from '../images/temoin_marketing2.webp';
import temoin3 from '../images/temoin_marketing3.webp';
import monImage from '../images/marketing_com_1920x780.webp';
import ctaBackground from '../images/formation_marketing_communication_900x500.webp';

const MarketingCommunication = () => {
  const { t } = useTranslation();

  // Données pour le composant Counter (statistiques)
  const statsData = [
    { icon: faUsers, target: 3, label: t('clients_satisfaits'), suffix: '+', color: '#6b3fa0' },
    { icon: faFileAlt, target: 0, label: t('nbre_formations'), suffix: '+', color: '#90ee90' },
    { icon: faFolder, target: 3, label: t('nbre_projets'), suffix: '+', color: '#ffb74d' },
    { icon: faAward, target: 2, label: t('annees_experience'), suffix: '+', color: '#f06292' },
  ];

  // Données pour les témoignages
  const testimonialsData = [
    {
      text: t('msg_temoin1_marketing'),
      name: 'Sarah Mensah',
      role: t('role_temoin1_marketing'),
      image: temoin1,
    },
    {
      text: t('msg_temoin2_marketing'),
      name: 'Mohamed Diallo',
      role: t('role_temoin2_marketing'),
      image: temoin2,
    },
    {
      text: t('msg_temoin3_marketing'),
      name: 'Chantal Ngo',
      role: t('role_temoin3_marketing'),
      image: temoin3,
    },
  ];

  // Compétences du département (tags)
  const skills = [
    { label: t('skill1_departement_markCom'), color: '#6b3fa0' },
    { label: t('skill2_departement_markCom'), color: '#6b3fa0' },
    { label: t('skill3_departement_markCom'), color: '#6b3fa0' },
    { label: t('skill4_departement_markCom'), color: '#6b3fa0' },
  ];

  return (
    <div className="marketing-communication-page">
      {/* Hero */}
      <DepartmentHero
        title={t('depart_marketing_card_titre_Notre_expertise')}
        subtitle={t('sous_titre_departement_markCom')}
        breadcrumb={[
          { label: t('marketing_card_titre_Notre_expertise') },
        ]}
        background={monImage}
        badge="Services / Marketing & Communication"
        height="large"
      />

      {/* About */}
      <DepartmentAbout
        chefImage={chefImage}
        chefName="M. Ulrich BOTCHOUANG"
        chefRole={t('CHEF_departement_info')}
        chefSocial={[
          { icon: 'facebook', url: 'https://www.facebook.com/share/1F9cXh6Ybg/' },
          { icon: 'whatsapp', url: 'https://wa.me/237695264171' },
          // LinkedIn non fourni dans l'HTML original
          { icon: 'tiktok', url: 'https://www.tiktok.com/@atccommunication2?_t=ZM-8zxK7oAVf5A&_r=1' },
        ]}
        logoImage={logoMarketing}
        title={t('depart_marketing_card_titre_Notre_expertise')}
        subtitle={t('sous_titre_departement_markCom')}
        description={t('msg_departement_markCom')}
        skills={skills}
      />

      {/* CTA */}
      <DepartmentCTA
        title={t('titre_devis_departement_info')}
        subtitle={t('sous_titre_devis_departement_info')}
        primaryButton={{ label: t('btn_devis_departement_info'), link: '/contact' }} 
        secondaryButton={{ label: t('btn_FORMATION_devis_departement_info'), link: '/formation' }}
        backgroundImage={ctaBackground} 
        badge="Solutions Marketing"
        formationLink="/formation/marketing" 
      />

      {/* Services */}
      <DepartmentServices
        title={t('titre_service_departement_info')}
        subtitle={t('sous_titre_service_departement_info')}
        services={[
          {
            title: t('strategie_titre_service_marketing'),
            icon: faChartBar,
            color: '#0066cc',
            frontDesc: t('strategie_msg2_service_marketing'),
            backDesc: t('strategie_msg1_service_marketing'),
            image: strategieImg,
            overlayColor: 'rgba(0, 102, 204, 0.66)',
          },
          {
            title: t('digital_titre_service_marketing'),
            icon: faMobileAlt,
            color: '#c8a02b',
            frontDesc: t('digital_msg2_service_marketing'),
            backDesc: t('digital_msg1_service_marketing'),
            image: digitalImg,
            overlayColor: 'rgba(200, 160, 43, 0.66)',
          },
          {
            title: t('creation_titre_service_marketing'),
            icon: faPaintBrush,
            color: '#107a3e',
            frontDesc: t('creation_msg2_service_marketing'),
            backDesc: t('creation_msg1_service_marketing'),
            image: creationImg,
            overlayColor: 'rgba(16, 122, 62, 0.66)',
          },
          {
            title: t('presse_titre_service_marketing'),
            icon: faNewspaper,
            color: '#6b3fa0',
            frontDesc: t('presse_msg2_service_marketing'),
            backDesc: t('presse_msg1_service_marketing'),
            image: presseImg,
            overlayColor: 'rgba(107, 63, 160, 0.66)',
          },
          {
            title: t('analyse_titre_service_marketing'),
            icon: faChartLine,
            color: '#e67e22',
            frontDesc: t('analyse_msg2_service_marketing'),
            backDesc: t('analyse_msg1_service_marketing'),
            image: analyseImg,
            overlayColor: 'rgba(230, 126, 34, 0.66)',
          },
          {
            title: t('international_titre_service_marketing'),
            icon: faGlobe,
            color: '#6b3fa0',
            frontDesc: t('international_msg2_service_marketing'),
            backDesc: t('international_msg1_service_marketing'),
            image: internationalImg,
            overlayColor: 'rgba(107, 63, 160, 0.85)',
          },
        ]}
      />

      {/* Statistiques */}
      <Counter stats={statsData} isDark={true} showBar={true} />

      {/* Témoignages */}
      <Testimonials
        title={t('temoignage')}
        subtitle={t('sous_titre_temoignage')}
        testimonials={testimonialsData}
        isDark={false}
      />
    </div>
  );
};

export default MarketingCommunication;